import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import {
  INLegsSearchParam,
  INLegsTableReport,
  NLegSendMode,
} from "../../../Interfaces/nLegsInterfaces";
import { getNLegsOrderTable } from "../../../Requests/nLegsRequests";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  onNLegsOrderFormValuesChange,
  setNLegsOrderTableFetchDataFlag,
} from "../../../Features/NLegs/nLegsSlice";
import { NLegOrderTableAdditional } from "./Additional";
import { createContext } from "react";
import PrioritySequence from "../PrioritySequence";

interface IProps {
  searchParam: INLegsSearchParam;
  legCount: number;
}

export const NLegOrderTableSearchParamContext = createContext({
  searchParam: {} as INLegsSearchParam,
  legCount: 0,
});

const NLegsOrderTable = ({ searchParam, legCount }: IProps) => {
  const flag = useAppSelector((store) => store.nLegs.orderTableFetchDataFlag);
  const dispatch = useAppDispatch();

  const tableRowClickHandler = (row: INLegsTableReport) => {
    dispatch(
      onNLegsOrderFormValuesChange({
        name: "uNLegsItems",
        value: row.instrumentInfo,
      })
    );
    dispatch(onNLegsOrderFormValuesChange({
      name: "sendMode",
      value: row.sendMode === "ترتیبی" ? NLegSendMode.Sequential : NLegSendMode.Simultaneous,
      name2: "sendPriorities",
      value2: row.sendOrder === "-" ? undefined : row.sendOrder.split("-").map(Number),
    }));
  };

  return (
    <div className="overflow-auto order-table">
      <TableTemplate<INLegsSearchParam, INLegsTableReport>
        refreshTableTime={10000}
        withSort
        getDataTable={(
          searchParam,
          offset,
          pageSize,
          sortingType,
          additional,
          axiosOptions
        ) =>
          getNLegsOrderTable({
            legCount,
            offset,
            pageSize,
            searchParam,
            sortingType,
            additional,
            axiosOptions,
          })
        }
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <NLegOrderTableSearchParamContext.Provider
            value={{ searchParam, legCount }}
          >
            <CommonTableUI
              withSelect
              reports={reports}
              onAction={() => {
                if (onAction) {
                  onAction();
                  dispatch(setNLegsOrderTableFetchDataFlag(false));
                }
              }}
              onTableRowClick={tableRowClickHandler}
              sortingType={sortingType}
              setSortingType={setSortingType}
              refreshFlag={flag}
              AdditionalBody={NLegOrderTableAdditional}
              renderCell={(row, header) => header.headerName === "SendOrder"
                ? <PrioritySequence value={row.sendOrder} /> : undefined}
              tableBoxClassName="max-h-[500px] overflow-auto"
            />
          </NLegOrderTableSearchParamContext.Provider>
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default NLegsOrderTable;
